// extracted by mini-css-extract-plugin
export default {"box":"D9aPjdBFfsVSZOrLMTCY","checkboxContainer":"gr7NDhL55ay1FIiThiXg","dayCheckbox":"pdhxwsg2i6DAk465EMSL","cancelDayBtn":"euhDToUEufJBBt9ZnGpF","error":"JcT9K1qZaGUcSi8H49bC"};